import { z } from "zod";
export const ProviderRollbackRehearsalV1Schema = z
    .object({
    schemaVersion: z.literal("provider-rollback-rehearsal.v1.0"),
    localTargetedProofComplete: z.literal(true),
    hostedOrExternalProofClaimed: z.literal(false),
    recordedAt: z.string().datetime(),
})
    .strict();
export function recordLocalProviderRollbackRehearsal(recordedAt) {
    return ProviderRollbackRehearsalV1Schema.parse({
        schemaVersion: "provider-rollback-rehearsal.v1.0",
        localTargetedProofComplete: true,
        hostedOrExternalProofClaimed: false,
        recordedAt,
    });
}
//# sourceMappingURL=provider-rollback-rehearsal.js.map